import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { useData } from '@hooks/useData';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { ICliente } from '@model/Cliente';
import IFatura from '@model/Fatura';
import { useRelatorioService } from '@services/RelatorioService';
import React from 'react';
import { InadimplenciaDetalhesTable } from './InadimplenciaDetalhesTable';

export type InadimplenciaDetalhesModalProps = {
    cliente: ICliente
    modal: IModalWindow
}

export function InadimplenciaDetalhesModal ({ cliente, modal }: InadimplenciaDetalhesModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const data = useData<IFatura>();

    const relatorioService = useRelatorioService();
    
    const handleEnter = React.useCallback(() => {
        data.clear();

        if (!loading.isLoading) {
            loading.start();
            relatorioService.ListarInadimplenciaFaturas(cliente.clienteId)
                .then(data.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [cliente.clienteId, data, loading, message.showException, relatorioService]);

    return (
        <ModalWindow
            modal={modal}
            size="lg"
            disabled={loading.isLoading}
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Composição da Inadimplência de ${cliente.nome} (${cliente.clienteId})`}
            />
            
            <ModalWindowContent>
                <InadimplenciaDetalhesTable 
                    data={data}
                />
            </ModalWindowContent>
        </ModalWindow>
    )
}